/* esm.sh - bail@2.0.2 */
function t(i){if(i)throw i}export{t as bail};
//# sourceMappingURL=bail.mjs.map